import { render } from "./Servicos.vue?vue&type=template&id=ee633f18"
const script = {}

import "./Servicos.vue?vue&type=style&index=0&id=ee633f18&lang=css"
script.render = render

export default script